import React from "react";
import { HStack, IconButton, Text } from "@chakra-ui/react";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";

export const QuantityInput = ({ value, onChange, min = 0, max = 7 }) => {
    const handleDecrease = () => onChange(Math.max(min, value - 1));
    const handleIncrease = () => onChange(Math.min(max, value + 1));
  
    return (
      <HStack
        border="1px solid"
        borderColor="gray.300"
        borderRadius="full"
        px={2}
        py={0.5}
        spacing={2}
        minW="90px"
        justify="space-between"
      >
        <IconButton
          icon={<MinusIcon />}
          aria-label="Minder"
          size="xs"
          p={2}
          onClick={handleDecrease}
          variant="ghost"
          isDisabled={value <= min}
        />
        <Text fontSize="sm" minW="12px" textAlign="center">
          {value}
        </Text>
        <IconButton
          icon={<AddIcon />}
          aria-label="Meer"
          size="xs"
          p={2}
          onClick={handleIncrease}
          variant="ghost"
          isDisabled={value >= max}
        />
      </HStack>
    );
  };
  